// Shared size + finish/colour options for the storefront and admin (jewellery).

// Quick-pick sizes in the admin. Bangle sizes (inner diameter, inches) first, then
// common UK ring sizes; any other label (e.g. "Ring O") can still be typed in.
export const SIZES = ["2.2", "2.4", "2.6", "2.8", "2.10", "Adjustable", "Ring J", "Ring L", "Ring N", "Ring P", "Ring R"];

// Metal finishes first, then stone / enamel colours. name -> swatch hex.
export const COLOUR_PALETTE = [
  // Metal finishes
  { name: "Gold", hex: "#D4AF37" },
  { name: "Antique Gold", hex: "#B08D57" },
  { name: "Matte Gold", hex: "#C9A85C" },
  { name: "Rose Gold", hex: "#E0A8A0" },
  { name: "Silver", hex: "#C4C4C4" },
  { name: "Oxidised Silver", hex: "#7A7A7A" },
  { name: "Rhodium", hex: "#E5E4E2" },
  { name: "Two Tone", hex: "#CBB38A" },
  // Stone / enamel colours
  { name: "White", hex: "#FFFFFF" },
  { name: "Pearl", hex: "#F3EBDD" },
  { name: "Ivory", hex: "#FFFFF0" },
  { name: "Ruby", hex: "#9B111E" },
  { name: "Red", hex: "#C0392B" },
  { name: "Maroon", hex: "#7B241C" },
  { name: "Pink", hex: "#EC5FA6" },
  { name: "Rani Pink", hex: "#D6006E" },
  { name: "Peach", hex: "#FFB49A" },
  { name: "Coral", hex: "#FF6F61" },
  { name: "Orange", hex: "#E67E22" },
  { name: "Yellow", hex: "#F4D03F" },
  { name: "Emerald", hex: "#046307" },
  { name: "Green", hex: "#2E8B57" },
  { name: "Mint", hex: "#98D7C2" },
  { name: "Turquoise", hex: "#30B8C4" },
  { name: "Sapphire", hex: "#0F52BA" },
  { name: "Blue", hex: "#1F4E9C" },
  { name: "Navy", hex: "#1B2A4A" },
  { name: "Amethyst", hex: "#9966CC" },
  { name: "Purple", hex: "#7D3C98" },
  { name: "Black", hex: "#1A1A1A" },
  { name: "Multicolour", hex: "#B5651D" },
];

const COLOUR_MAP = COLOUR_PALETTE.reduce((m, c) => {
  m[c.name.toLowerCase()] = c.hex;
  return m;
}, {});

// Resolve a colour name to a displayable hex/CSS colour.
export const colourHex = (name) => {
  if (!name) return "#cccccc";
  const key = String(name).trim().toLowerCase();
  if (COLOUR_MAP[key]) return COLOUR_MAP[key];
  // fall back to the raw name (works for valid CSS colour keywords), else grey
  return /^#|^rgb|^[a-z]+$/i.test(key.replace(/\s/g, "")) ? key.replace(/\s/g, "") : "#cccccc";
};

// A near-white swatch needs a visible ring.
export const isLightColour = (hex) => {
  const h = (hex || "").replace("#", "");
  if (h.length !== 6) return false;
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) > 225;
};
